export const questions = [
  {
    id: 'bd23249d2d-ff60-466c-bbeb-c05e559b98be',
    title: 'Как мне принять участие в акции?',
    text: (
      <p className="accordion__text">Чтобы принять участие в акции, купите продукты SPLAT Kids или SPLAT Junior из списка в любом магазине ТС «Магнит Семейный», «Магнит у дома», «Магнит косметик» или «Магнит экстра». Затем зарегистрируйте чек на нашем сайте и ожидайте подведения итогов!
      </p>
    )
  },
  {
    id: 'cfd21238a-8219-4950-bf06-198dfeb644b2',
    title: 'Как я узнаю, что я выиграл приз?',
    text: (
      <p className="accordion__text">Мы опубликуем список победителей на сайте в разделе «Победители», а также свяжемся с вами по указанной электронной почте.
      </p>
    )
  },
  {
    id: '9d613a2606-cdc6-44f3-8944-725c7e0cbe27',
    title: 'Как я смогу получить свой подарок?',
    text: (
      <p className="accordion__text">3000 бонусов мы начислим на вашу бонусную карту Магнит, указанную при регистрации чека, а главный приз — вручим лично и организуем поездку на космодром Байконур.
      </p>
    )
  },
  {
    id: '955d3a2606-cdc6-44f3-8944-725c7e0cbe23',
    title: 'Кто является организатором акции?',
    text: (
      <p className="accordion__text">Организатор акции — общество с ограниченной ответственностью «СПЛАТ», ОГРН 1057746078345, адрес местонахождения: 174350, Новгородская область, Окуловский район, территория 2й км автодороги Окуловка-Кулотино, дом 1, строение 2, помещение 15, идентификационный номер налогоплательщика (ИНН): 7703539871, КПП: 531101001
      </p>
    )
  },
  {
    id: '944d3a2606-cdc6-44f3-8944-725c7e0cbe24',
    title: 'Какие сроки проведения акции?',
    text: (
      <>
        <p className="accordion__text">Общий срок проведения Акции, включая выдачу призов: с 00:00ч. 24.08.2022 года по 23:59 30.11.2022 года.
        </p>
        <p className="accordion__text">
          Срок совершения покупок и регистрации чеков в Акции: с 24.08.2022 по 21.09.2022 года.
        </p>
      </>
    )
  },
  {
    id: '933d3a2606-cdc6-44f3-8944-725c7e0cbe25',
    title: 'Когда будут результаты розыгрыша призов?',
    text: (
      <>
        <p className="accordion__text">Определение победителей, получающих Призы Акции 1го уровня (бонусы на карту Магнит) происходит в 4 этапа:</p>
        <p className="accordion__text">- для участников, зарегистрировавших чеки в период с 24.08.2022 года по 30.08.2022 года – 01.09.2022 года</p>
        <p className="accordion__text">- для участников, зарегистрировавших чеки в период с 31.08.2022 года по 06.09.2022 года – 08.09.2022 года</p>
        <p className="accordion__text">- для участников, зарегистрировавших чеки в период с 07.09.2022 года по 13.09.2022 года – 15.09.2022 года</p>
        <p className="accordion__text">- для участников, зарегистрировавших чеки в период с 14.09.2022 года по 21.09.2022 года – 23.09.2022 года</p>
        <p className="accordion__text">Определение победителя, получающего Главный Приз Акции: 23.09.2022 г.</p>
      </>
    )
  },
  {
    id: '91d3a2606-cdc6-44f3-8944-725c7e0cbe26',
    title: 'Кто может участвовать в акции?',
    text: (
      <p className="accordion__text">Участниками Акции могут являться дееспособные граждане РФ, достигшие возраста 18 лет, постоянно проживающие на территории РФ, принявшие Правила проведения Акции в полном объеме.
      </p>
    )
  },
  {
    id: '92d3a2606-cdc6-44f3-8944-725c7e0cbe27',
    title: 'Нужно ли платить налог за приз?',
    text: (
      <>
        <p className="accordion__text">Согласно законодательству РФ не облагаются налогом на доходы физических лиц (НДФЛ) доходы, не превышающие в совокупности 4 000,00 руб. (четыре тысячи рублей 00 копеек), полученные за налоговый период (календарный год) от организаций, в т.ч., в виде подарков, выигрышей или призов в проводимых конкурсах, играх и других мероприятиях в целях рекламы товаров (работ, услуг) (п. 28 ст. 217 НК РФ).</p>

        <p className="accordion__text">В соответствии с требованиями действующего законодательства РФ Организатор Акции исполняет обязанности налогового агента, а именно исчисляет и удерживает из денежной части Главного приза Акции сумму налога на доходы физических лиц в соответствии с Налоговым кодексом Российской Федерации.
          Принимая участие в Акции и соглашаясь с настоящими Правилами, Участник считается надлежащим образом проинформирован о вышеуказанной обязанности об уплате НДФЛ в бюджет РФ.
        </p>
      </>
    )
  }
];